import React, { useEffect, useState } from 'react';

export default function DocsToc({ content }) {
    const [headings, setHeadings] = useState([]);
    const [activeId, setActiveId] = useState('');

    // Extract headings from content
    useEffect(() => {
        if (!content) return;

        const extractedHeadings = [];
        const lines = content.split('\n');

        lines.forEach((line) => {
            const h2Match = line.match(/^## (.+)$/);
            const h3Match = line.match(/^### (.+)$/);

            if (h2Match) {
                const text = h2Match[1].trim();
                const id = text
                    .toLowerCase()
                    .replace(/[^a-z0-9\s-]/g, '')
                    .replace(/\s+/g, '-')
                    .replace(/-+/g, '-')
                    .trim();
                extractedHeadings.push({ id, text, level: 'h2' });
            } else if (h3Match) {
                const text = h3Match[1].trim();
                const id = text
                    .toLowerCase()
                    .replace(/[^a-z0-9\s-]/g, '')
                    .replace(/\s+/g, '-')
                    .replace(/-+/g, '-')
                    .trim();
                extractedHeadings.push({ id, text, level: 'h3' });
            }
        });

        setHeadings(extractedHeadings);
        // Set first heading as active initially
        if (extractedHeadings.length > 0) {
            setActiveId(extractedHeadings[0].id);
        }
    }, [content]);

    // Scroll spy
    useEffect(() => {
        if (headings.length === 0) return;

        const handleScroll = () => {
            const scrollPosition = window.scrollY + 120;

            let currentActive = headings[0]?.id || '';

            for (const { id } of headings) {
                const element = document.getElementById(id);
                if (element) {
                    const offsetTop = element.offsetTop;
                    if (scrollPosition >= offsetTop) {
                        currentActive = id;
                    }
                }
            }

            setActiveId(currentActive);
        };

        window.addEventListener('scroll', handleScroll, { passive: true });
        handleScroll(); // Initial check

        return () => window.removeEventListener('scroll', handleScroll);
    }, [headings]);

    if (headings.length === 0) {
        return null;
    }

    const handleClick = (e, id) => {
        e.preventDefault();
        const element = document.getElementById(id);
        if (element) {
            const yOffset = -100;
            const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({ top: y, behavior: 'smooth' });
            setActiveId(id);
        }
    };

    return (
        <aside className="docs_toc">
            <div className="docs_toc_header">On this page</div>
            <ul className="docs_toc_list">
                {headings.map(({ id, text, level }) => (
                    <li key={id} className={`docs_toc_item ${level}`}>
                        <a
                            href={`#${id}`}
                            className={activeId === id ? 'active' : ''}
                            onClick={(e) => handleClick(e, id)}
                        >
                            {text}
                        </a>
                    </li>
                ))}
            </ul>
        </aside>
    );
}
